import { observable, action } from 'mobx';
import axios from 'axios';
import ApiClient from './ApiClient';
import { get, set } from 'lodash';

var ObjectID = require('bson-objectid');

export default class FormDataStore extends ApiClient {
  // https://blog.risingstack.com/handling-react-forms-with-mobx-observables/
  @observable
  createUserAccountState = 'pending'; // 'pending' / 'done' / 'error'
  @observable
  formDataState = 'pending'; // 'pending' / 'done' / 'error'
  @observable
  formUploadState = 'pending'; // 'pending' / 'done' / 'error'
  @observable
  imagesUploadState = 'pending'; // 'pending' / 'done' / 'error'
  @observable
  customerOpen = true;
  @observable
  caseOpen = true;
  @observable
  customerCase = {};
  @observable
  caseLanguage = null;
  @observable
  customerCaseRoot = {};
  @observable
  editedUser = {
    username: '',
    password: '',
    templateRightsLevel: 'admin',
    passwordConf: 'fdgdfg',
    userInformation: {
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      jobTitle: ''
    }
  };

  // create new user account
  @action
  createUserAccount() {
    this.createUserAccountState = 'pending';
    this.api()
      .post('/api/v1/user/create', this.editedUser, {
        headers: { 'content-type': 'application/json' }
      })
      .then(response => response.data)
      .then(this.createUserAccountSuccess)
      .catch(this.createUserAccountError);
  }

  @action.bound
  createUserAccountSuccess(userInformation) {
    console.log(userInformation);
    this.currentUser = userInformation;
    this.createUserAccountState = 'done';
  }

  @action.bound
  createUserAccountError(error) {
    this.createUserAccountState = 'error';
    console.log(error);
  }

  // @TODO edit user account client-side portion, still work in progress
  @action
  editUserAccount() {
    this.editUserAccountState = 'pending';
    this.api()
      .post('/api/v1/user/edit', this.editedUser)
      .then(response => response.data)
      .then(this.editUserAccountSuccess)
      .catch(this.editUserAccountError);
  }

  @action.bound
  editUserAccountSuccess(userInformation) {
    console.log(userInformation);
    this.currentUser = userInformation;
    this.editUserAccountState = 'done';
  }

  @action.bound
  editUserAccountError(error) {
    this.editUserAccountState = 'error';
    console.log(error);
  }

  // Fetch Customer Case by _id
  @action
  fetchOneCustomerCase(id, language) {
    this.formDataState = 'pending';
    this.caseLanguage = language;
    this.api()
      .get(`/api/v1/cases/id/${id}`)
      .then(response => response.data)
      .then(this.fetchOneCustomerCaseSuccess)
      .catch(this.fetchOneCustomerCaseError);
  }

  @action.bound
  fetchOneCustomerCaseSuccess(customerCase) {
    this.customerCaseRoot = customerCase;
    this.customerCase = customerCase.translations.find(o => o.lang === this.caseLanguage);

    if (this.customerCase === undefined) {
      this.createCustomerCaseTranslation(customerCase._id, this.caseLanguage);
    } else {
      this.formDataState = 'done';
    }
  }

  @action.bound
  fetchOneCustomerCaseError(error) {
    this.formDataState = 'error';
  }

  @action
  createCustomerCaseTranslation(caseId, lang) {
    return this.api()
      .post(`/api/v1/cases/${caseId}/translations`, {
        lang
      }).then(() => {
        return this.fetchOneCustomerCase(caseId, this.caseLanguage);
      })
  }

  //seaches through a target object for a variable for specific name and return its reference
  @action.bound
  findObjectReference(targetObject, target) {
    return get(this[targetObject], target);
  }

  //add object to a array of specific name in specific named object in the store
  @action
  addObjectToArray(targetObject, targetArray, value) {
    var ref = this.findObjectReference(targetObject, targetArray);
    ref[ref.length] = value;
  }

  //remove object from a array of specific name in specific named object in the store
  @action
  removeObjectFromArray(targetObject, targetArray) {
    var ref = this.findObjectReference(targetObject, targetArray);
    ref.pop();
  }

  //change value of a variable of specific name in object of specific name in a object of specific name
  // used for storing data from the case edit view to variables of the mobx store
  @action
  assignValueToProperty(targetObject, id, targetArray, key, value) {
    if (!targetArray) {
      this[targetObject][key] = value;
    } else {
      var ref = this.findObjectReference(targetObject, targetArray);
      if (id) {
        const tableObject = ref.find(tableObject => tableObject['_id'] == id);
        tableObject[key] = value;
      } else {
        ref[key] = value;
      }
    }
  }

  @action
  assignValueToPath(targetObject, path, value) {
    set(this[targetObject], path, value);
  }

  // fetch variable of specific name from a variable of specific id from array of specific name from object of specific name
  @action
  fetchArrayVariable(targetObject, id, targetArray, key) {
    var ref = this.findObjectReference(targetObject, targetArray);
    var foo;
    ref.map(tableObject => {
      if (tableObject['_id'] == id) {
        foo = tableObject[key];
      }
    });
    return foo;
  }

  //remove object of specific id from a array of specific name from object of specific name
  @action
  removeObject(targetObject, targetArray, id) {
    var ticker = 0;
    var ref = this.findObjectReference(targetObject, targetArray);
    var tempRef = ref.filter(o => {
      return o._id !== id;
    });
    ref.splice(0, ref.length);
    tempRef.map(o => {
      ref[ticker++] = o;
    });
  }

  // toggle minimization of customer section of case edit view
  @action
  toggleCustomerOpen() {
    this.customerOpen = this.customerOpen ? false : true;
  }

  // toggle minimization of case section of case edit view
  @action
  toggleCaseOpen() {
    this.caseOpen = this.caseOpen ? false : true;
  }

  // save customer case
  @action
  saveCustomerCase() {
    this.formDataState = 'pending';
    this.api()
      .put(`/api/v1/cases/${this.customerCaseRoot._id}/translations/${this.customerCase._id}`, this.customerCase)
      .then(response => response.data)
      .then(this.saveCustomerCaseSuccess)
      .catch(this.saveCustomerCaseError);
  }

  @action.bound
  saveCustomerCaseSuccess() {
    this.formUploadState = 'done';
    console.log('success');
  }

  @action.bound
  saveCustomerCaseError(error) {
    this.formUploadState = 'error';
    console.log(error);
  }

  // upload customer logo in the case edit view
  @action
  uploadLogo(imageFile) {
    var fd = new FormData();
    fd.append('file', imageFile, imageFile.name);
    this.imageUploadState = 'pending';
    this.api()
      .post(`/api/v1/images/single`, fd)
      .then(response => response.data)
      .then(this.uploadLogoSuccess)
      .catch(this.uploadLogoError);
  }

  @action.bound
  uploadLogoSuccess(response) {
    this.assignValueToProperty(
      'customerCase',
      '',
      'customer',
      'logo',
      response.filename
    );
    this.imageUploadState = 'done';
    console.log('logo success');
  }

  @action.bound
  uploadLogoError(error) {
    this.imageUploadState = 'error';
    console.log(error);
  }

  //upload multiple pictures from the case edit view multi-picture upload
  @action
  uploadImages(imageFiles, callback) {
    console.log(imageFiles);
    var fd = new FormData();
    for (const imageFile of imageFiles) {
      fd.append('file', imageFile, imageFile.name);
    }
    this.imagesUploadState = 'pending';
    this.api()
      .post(`/api/v1/images`, fd)
      .then(response => response.data)
      .then(callback)
      .then(this.uploadImagesSuccess)
      .catch(this.uploadImagesError);
  }

  @action.bound
  uploadImagesSuccess(response) {
    this.imageUploadState = 'done';
    console.log('upload success');
  }

  @action.bound
  uploadImagesError(error) {
    this.imageUploadState = 'error';
    console.log(error);
  }

  //remove image
  @action
  removeImage(id, callback) {
    console.log('start remove');
    this.imageUploadState = 'pending';
    this.api()
      .get(`/api/v1/images/remove/${id}`)
      .then(response => response.data)
      .then(callback)
      .then(this.removeImageSuccess)
      .catch(this.removeImageError);
  }

  @action.bound
  removeImageSuccess(response) {
    this.imageUploadState = 'done';
    console.log('remove success');
  }

  @action.bound
  removeImageError(error) {
    this.imageUploadState = 'error';
    console.log(error);
  }
}



// WEBPACK FOOTER //
// ./src/store/FormDataStore.js